/*
 *   File : order filter.js
 *   Author : https://evoqins.com
 *   Description : Order filter modal component
 *   Integrations : 
 *   Version : 1.0.0
*/

//Style
import style from "../../Styles/Component/modal.module.scss";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const OrderFilterModal = (props) => {

    return (
        <div className={`${style.e_basket_sort_modal} e-bg-white border-radius-16 p-3 position-absolute top-50px end-0 z-index-999 w-360px w-280px-res`}>
            <div className='pb-2 d-flex align-items-center justify-content-between'>
                <h6 className='mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-700 line-height-24px'>
                    Filter
                </h6>
                {/* <div className='d-flex gap-1 align-items-center cursor-pointer'
                    onClick={props.handleClear}>
                    <span className='e-text-primary-color e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Clear all
                    </span>
                    <Icon icon="clear-icon"
                        size="16px"
                        className="d-flex" />
                </div> */}
            </div>

            <div className={`${style.e_basket_filter_modal_body} overflow-scroll pb-2`}>
                {/* <div className='pt-4'>
                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Order Type
                    </p>
                    <div className='mt-3 d-flex gap-2'>
                        {
                            props.orderType.map((option, key) => (
                                <p key={key}
                                    className={`${props.selectedOrderTypeId.includes(option.id) ? "e-border-0-5-ocean-blue e-bg-magnolia e-text-chinese-black" : "e-border-0-5-light-silver e-text-outer-space"} e-font-14-res border-radius-24 px-2 padding-6px-tb px-sm-3 cursor-pointer mb-0  e-alt-font-lato e-font-16 e-font-weight-600 line-height-16px`}
                                    onClick={() => props.handleSelectOrderType(option.id)}>
                                    {option.label}
                                </p>
                            ))}
                    </div>
                </div> */}

                {/* <div className='pt-4'>
                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Payment status
                    </p>
                    <div className='mt-3 d-flex  gap-2'>
                        {
                            props.paymentStatus.map((option, key) => (
                                <p key={key}
                                    className={`${props.selectedPaymentStatusId.includes(option.id) ? "e-border-0-5-ocean-blue e-bg-magnolia e-text-chinese-black" : "e-border-0-5-light-silver e-text-outer-space"}  e-font-14-res border-radius-24 px-2 padding-6px-tb px-sm-3 cursor-pointer mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-16px`}
                                    onClick={() => props.handleSelectPaymentStatus(option.id)}>
                                    {option.label}
                                </p>
                            ))
                        }
                    </div>
                </div> */}

                <div className='pt-4'>
                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Order status
                    </p>
                    <div className='mt-3 d-flex gap-2'>
                        {props.orderStatus.map((option, key) => (
                            <p key={key}
                                className={`${props.selectedOrderStatusId === option.id ? "e-border-0-5-ocean-blue e-bg-magnolia e-text-chinese-black" : "e-border-0-5-light-silver e-text-outer-space"} e-font-14-res border-radius-24 px-2 padding-6px-tb px-sm-3 cursor-pointer mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-16px`}
                                onClick={() => props.handleSelectOrderStatus(option.id)}>
                                {option.label}
                            </p>
                        ))}
                    </div>
                </div>
            </div>

            {/* Custom buttons */}
            <div className='pt-2 d-flex justify-content-end gap-3'>
                <SecondaryButton name="Cancel"
                    className="bg-transparent"
                    padding="padding-40px-lr"
                    onPress={props.handleCancel} />
                <PrimaryButton name="Apply"
                    padding="padding-40px-lr py-2"
                    onPress={props.handleApply} />
            </div>
        </div>
    )
}

export default OrderFilterModal;
